export const boundaryErrorMessage = (recovery)=>recovery === 'stale-not-reloaded' ? 'Stale bundle reload did not recover the chunk' : 'ErrorBoundaryPage caught an error';
